import {
    GET_DEVICE_CONFIG,
    GET_DEVICE_CONFIG_SUCCESS,
    GET_DEVICE_CONFIG_FAIL,
} from '../../../constants/maintenance/alarmConfigurationConstants/deviceConfigurationConstants.js';

/**
 * Reducer function for managing device alarm configuration state.
 *
 * This reducer handles actions related to fetching device alarm configuration.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the device alarm configuration.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const deviceConfigReducer = (state = { device: {} }, action) => {
    switch (action.type) {
        case GET_DEVICE_CONFIG:
            return {
                loading: true,
            };
        case GET_DEVICE_CONFIG_SUCCESS:
            return {
                loading: false,
                device: action.payload,
            };
        case GET_DEVICE_CONFIG_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
